import { render, staticRenderFns } from "./RelatorioAssinaturas.vue?vue&type=template&id=0b08871b&scoped=true&"
import script from "./RelatorioAssinaturas.vue?vue&type=script&lang=js&"
export * from "./RelatorioAssinaturas.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioAssinaturas.vue?vue&type=style&index=0&id=0b08871b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b08871b",
  null
  
)

export default component.exports